import {Fragment, h} from 'preact';
import { formatPriceWithSymbol } from  '../../tools';
import BlockItemInnerToggle from './BlockItemInnerToggle';
import DeviceDetailsInfo from './DeviceDetailsInfo';

export default function BlockItemToggle({item, toggleHandler}){
    return (
        <div data-id={item.method} className="block-item account-details__block">
            <div onClick={() => toggleHandler(item.method)} className="row block-item__head">
                <div className={'col col-12 col-lg-6 account-details__legend-item account-details__legend-item_' + item.method}>
                    {item.title}
                </div>
                <div className="col col-12 col-lg-6">
                    {formatPriceWithSymbol(item.amount)}
                </div>
            </div>
            <div className="block-item__data account-details__data">
                {
                    <Fragment>
                        {
                            item.data.length > 1 && item.data.map((dataItem, index) => (
                                <div className="row account-details__block-field">
                                    <BlockItemInnerToggle item={dataItem} method={item.method} toggleHandler={toggleHandler}/>
                                </div>
                            ))
                        }
                        {
                            item.data.length > 1 && item.total && <DeviceDetailsInfo data={item.total} />
                        }
                    </Fragment>
                }
                {item.data.length == 1 &&
                    <Fragment>
                        <DeviceDetailsInfo data={item.data[0].data} />
                        {
                            item.total && <DeviceDetailsInfo data={item.total} />
                        }
                    </Fragment>
                }
            </div>
        </div>
    )
}
